const cp = [
    {   // 0
        tle : `១.(ក).នាយក/នាយិកាសាលាមត្តេយ្យសិក្សាដាច់`, 
        des : `
        - កម្រិតវប្បធម៌៖ សូមបំពេញកម្រិតវប្បធម៌ដែលខ្ពស់បំផុត ដោយបំពេញតាមការបែងចែកកម្រិតវប្បធម៌ក្នុងចំណុចទី ៤(គ)។
­        - ចំនួនម៉ោងបង្រៀនក្នុង១សប្ដាហ៍៖ ជាចំនួនម៉ោងបង្រៀនតាមថ្នាក់ជាក់ស្ដែង   មិនមែនចំនួនម៉ោងទៅធ្វើការធម្មតា។
        `
    },
    {   // 1
        tle : `១.(ខ).សាលាមត្តេយ្យសិក្សា`,
        des : `
        ទីតាំងសាលារៀន
            - តំបន់ក្រុង៖ ជាតំបន់មជ្ឈមណ្ឌលនយោបាយ សេដ្ឋកិច្ច វប្បធម៌ហើយមាន   ប្រជាជនរស់នៅច្រើនកុះករដូចជារាជធានីភ្នំពេញ និងក្រុង។
            - តំបន់ជនបទ៖ ជាស្រុកដែលស្ថិតនៅក្នុងតំបន់ធ្វើស្រែចម្ការ ខុសពីរាជធានីភ្នំពេញ និងទីក្រុង។
            - សាលារៀនបណ្ដែតទឹក៖ ជាសាលារៀនដែលស្ថិតនៅលើក្បូនបណ្ដែតទឹក ហើយ ធ្វើចលនាតាមទឹកឡើង និងទឹកស្រក (មិនមែនសាលារៀនលិចទឹកទេ)
        `
    },
    {   // 2
        tle : `២.(ក).អាយុ`,
        des : `
        ­- កុមារអាយុ ៣ឆ្នាំ គឺកុមារដែលមានអាយុ ៣៦ខែ ដោយរាប់ត្រឹមថ្ងៃទី ០១/១១/២០២៦។ ឧទាហរណ៍៖ កុមារអាយុ៣ឆ្នាំ ត្រូវចូលរៀន គឺជាកុមារដែលកើតក្នុងចន្លោះថ្ងៃទី០១ ខែវិច្ឆិកា ឆ្នាំ២០២៣ ដល់ថ្ងៃទី០១ ខែវិច្ឆិកា ឆ្នាំ២០២៦។
        `
    },
    {   // 3
        tle : `២.(ខ).សិស្សពិការ សិស្សជួបការលំបាកផ្នែកសុខភាព និងសិស្សជួបការលំបាកតាមកម្រិតថ្នាក់`,
        des : `
        - ពិបាកក្នុងការធ្វើចលនា ៖ ដាច់ដៃ ដាច់ជើង    ស្វិតដៃ   ស្វិតជើង  ស្វិតសាច់ដុំ  គាំងសន្លាក់  បាក់ឆ្អឹង  សាច់ដុំរួញ   ខូចប្រព័ន្ធបញ្ជាចលនារបស់ខួរក្បាល ។
        - ជើងខ្វេរ ជើងកែក ជើងទន់ ខូចទ្រង់ទ្រាយពីកំណើត ស្លាប់មួយចំហៀងខ្លួន កំហូចឆ្អឹងខ្នង (កោងទៅមុខ កោងទៅចំហៀង និងកោងទៅក្រោយ) ពិការដោយសាផលវិបាកនៃជំងឺ ខូចស្មាម្ខាង គ្រេចធ្ងន់ធ្ងរ រលាកធ្ងន់ធ្ងរ (ភ្លើង ទឹកអាស៊ីត...)។
        - ពិបាកក្នុងការស្ដាប់៖ ថ្លង់ ត្រចៀកអត់រន្ធ ពុំមានក្រដាសត្រចៀក ធ្លាយក្រដាសត្រចៀក ហៀរអំបៅអំបែកធ្ងន់ធ្ងរ រន្ធត្រចៀកមានដុំពក។
        - ពិបាកក្នុងការនិយាយ៖ និយាយត្រឡាន់ (អណ្ដាតធំ) ត្រដិតធ្ងន់ធ្ងរ ឆែបក្រអូម មាត់ ក្រឡើត ក្រងួរ  និយាយមិនច្បាស់ និយាយមិនចេញ។
        - ពិបាកក្នុងការមើល៖ ងងឹតភ្នែកម្ខាង ឬទាំងសងខាង ស្វិតសរសៃបាតភ្នែក     ភ្នែកលៀនមើលមិនឃើញ កន្ទុយថ្លែនធ្ងន់ធ្ងរ ភ្នែកឡើងបាយ ត្រាក់កូមធ្ងន់ធ្ងរ បណ្ដាលឱ្យមានប្រែងចាក់ភ្នែក ស្រលៀង ភ្នែកមីញ៉ូក ធ្លាក់ត្របកភ្នែក សម្លាកកញ្ចក់ភ្នែក សម្ពាធទឹកក្នុងភ្នែកកើន ឡើងរលាកសរសៃបាតភ្នែក ងងឹតពណ៌។
        - ពិការសរីរាង្គខាងក្នុង៖ ខ្សោយមុខងារសរីរាង្គ បេះដូង  ក្រលៀន ប្រព័ន្ធដង្ហើម តម្រងនោម  ពោះវៀន  ថ្លើម។
        - ពិការសតិបញ្ញា៖ បញ្ញាលូតលាស់យឺត រៀនខ្សោយ / ការចងចាំមានកម្រិត  ខូចប្រព័ន្ធបញ្ជាក្នុងខួរក្បាល និងជំងឺ(ដោនស៊ីនដ្រូម មានចរឹកទុយមុយ)
        - ពិការផ្លូវចិត្ត៖ អាក្រាត និយាយ សើច យំ ច្រៀងរាំ លេងតែម្នាក់ឯងខុសពីប្រក្រតី  ស្មឹងស្មាធិ៍ ជេរគេជេរឯង វាយ ឬ ប្រព្រឹត្តអំពើហិង្សាដោយមិនដឹងខ្លួន មិនដឹងគ្រោះថ្នាក់ ជំងឺមន្ទិលសង្ស័យ  វិកលចរិត  ខូចសតិអារម្មណ៍  តានតឹងផ្លូវចិត្ត ជំងឺធ្លាក់ទឹកចិត្ត ថប់អារម្មណ៍ ជំងឺវង្វេង ។
        - ពិការផ្សេងៗ៖ មុខមាត់ខូចទ្រង់ទ្រាយ ក្បាលធំ តឿ ក្រិន ពកក ផលវិបាកក្នុងការបំពេញមុខងារ ដោយសារគ្រោះថ្នាក់ និងជំងឺរ៉ាំរ៉ៃ ។ល។
        - ខ្វះអាហារូបត្ថម្ភធ្ងន់ធ្ងរ៖ កំណត់ដោយទម្ងន់ទាបខ្លាំងធៀបនឹងកម្ពស់ (ទាបជាងពិន្ទុ -3 Z-score ឬ <-3SD នៃខ្សែកោងលូតលាស់នៃទម្ងន់ធៀបនឹងប្រវែង/កម្ពស់របស់អង្គការសុខភាពពិភពលោក) ដោយការបាត់បង់ធ្ងន់ធ្ងរដែលអាចមើលឃើញឬដោយវត្តមាននៃការហើម។
        - កុមាររងគ្រោះដោយ HIV/AIDS៖ កុមារដែលបាត់បង់ឪពុកឬម្តាយ ឬទាំងពីរ ដោយរងផលប៉ះពាល់ដោយសារ HIV/AIDS ងាយរងគ្រោះដោយការឆ្លងHIV/AIDS។
        - កុមារដែលមកពីគ្រួសារក្រីក្រ៖ គ្រួសារដែលរកប្រាក់ចំណូល ៥០០០រៀលក្នុងមួយថ្ងៃ(១,២៥ដុល្លា) ឬ ដែលចំណាយលើរបបស្បៀងអាហារប្រចាំថ្ងៃ ៣៧០០រៀល ក្នុងមួយថ្ងៃ។ បើរកបានក្រោមនេះ ស្ថិតក្នុងចំណាត់ទីទ័លក្រ  បើរកបានស្មើ ឬលើសបន្តិចបន្តួច ស្ថិតក្នុងចំណាត់ ក្រីក្រ។ 
        `
    },
    {   // 4
        tle : `២.(ឃ).ចំនួនកុមារដើមឆ្នាំសិក្សា`,
        des : `
        - ជាចំនួនកុមារសរុបដែល បានបំពេញ នៅតារាងទី២.(ក)  ក្នុងតារាងជំរឿនស្ថិតិសាលារៀន ឆ្នាំសិក្សា២០២៦-២០២៧ គ្រប់ថ្នាក់ (កម្រិតទាប កម្រិតមធ្យម កម្រិតខ្ពស់ និងថ្នាក់ចម្រុះ)។
        - ចំនួនកុមារដើមឆ្នាំសិក្សា (២០២៦-២០២៧)៖ ជាចំនួនសិស្សជាក់ស្ដែងដែលមាននៅដើមឆ្នាំសិក្សា ២០២៦-២០២៧។
        - ចំនួនកុមារចុងឆ្នាំសិក្សា (២០២៥-២០២៦)៖ ជាចំនួនសិស្សជាក់ស្ដែងដែលមាននៅចុងឆ្នាំសិក្សា ២០២៥-២០២៦។
        - ចំនួនកុមារអាយុ៥ឆ្នាំដែលឆ្លងកាត់តេស្តស្តង់ដារ ឆ្នាំសិក្សា (២០២៥-២០២៦)៖ សំដៅទៅលើកុមារដែលបានធ្វើតេស្តក្នុងមួយឆ្នាំ បីដង បើសិនជាកុមារបានធ្វើ  តេស្តមួយដង ឬពីរដង មិនរាប់បញ្ចូលឡើយ។
        `
    },
    {   // 5
        tle : `៣.(ខ).ឯកសារបង្រៀន`,
        des : `
        - ជាសៀវភៅដែលទទួលបានពីក្រសួងអប់ យុវជន និងកីឡា សម្រាប់រៀបចំការបង្រៀន ទោះបីឆ្នាំណាក៏ដោយ។
        `
    },
    {   // 6
        tle : `៤.(ក).បុគ្គលិកបង្រៀន`,
        des : `
        គឺ
            ក.បុគ្គលិកដែលមានភារកិច្ចបង្រៀនប្រចាំថ្ងៃ
            ខ.នាយកសាលាមត្តេយ្យសិក្សា ដែលមានត្រឹម ៦ថ្នាក់ចុះ
            គ.នាយករងសាលាមត្តេយ្យសិក្សា ដែលមានត្រឹម ១០ថ្នាក់ចុះ
        បុគ្គលិកមិនបង្រៀនគឺ៖
            ក.បុគ្គលិកដែលមានភារកិច្ចប្រចាំថ្ងៃនៅការិយាល័យ/ទីចាត់ការ
            ខ.លេខាធិការ គណនេយ្យ ឆ្មាំ បុគ្គលិកពេទ្យ អ្នកបើកបរ អ្នកដាំស្លរ
            គ.នាយកសាលាមត្តេយ្យសិក្សា ដែលមានចាប់ពី ៧ថ្នាក់ឡើងទៅ
            ឃ.នាយករងសាលាមត្តេយ្យសិក្សា ដែលមានចាប់ពី ១១ថ្នាក់ឡើងទៅ
        បុគ្គលិកជាប់កិច្ចសន្យា៖ គឺជាបុគ្គលិកដែលចូលនិវត្តន៍ ឬជាអ្នកដែលមានបទពិសោធខ្ពស់ ហើយបានធ្វើកិច្ចសន្យាបង្រៀនថ្នាក់ណាមួយ ឬបន្តការងារដោយទទួលប្រាក់ឧបត្ថម្ភតាមកិច្ចសន្យានោះ។ បុគ្គលិកជាប់កិច្ចសន្យា មិនត្រូវរាប់បញ្ចូលក្នុងតារាងដទៃទៀតទេ។ 
        `
    },
    {
        tle : `៥.អគារ និងបរិក្ខារ`,
        des : `
        បើថ្នាក់មត្តេយ្យសិក្សាក្នុងសាលាបឋមសិក្សា សំណួរទី៥(ក) ផ្ទៃដីជាកម្មសិទ្ធិរបស់សាលារៀន និងទីធ្លាសាលារៀនមិនបាច់បំពេញទេ ត្រូវទុកឱ្យសាលាបឋមសិក្សាបំពេញ។ ឯផ្ទៃដីសរុបប្រើប្រាស់សម្រាប់បន្ទប់រៀន គឺគិតតែផ្ទៃបន្ទប់ខាងក្នុងថ្នាក់ ប្រើប្រាស់សម្រាប់មត្តេយ្យសិក្សាប៉ុណ្ណោះ។ ចំពោះសំណួរទី៥(ខ) និងទី៥(គ) មិនបាច់បំពេញខ្ទង់ចំនួនអគារទេ ឯខ្ទង់ចំនួនបន្ទប់ រាប់តែបន្ទប់សម្រាប់មត្តេយ្យសិក្សាទៅតាមស្ថានភាពបានហើយ។
        `
    }
]

export {
    cp
}

